// Anita Week 10 / Day 4 — Light of Map and Plan: Route, Time and Goal.
// Verbatim from FINAL Week 10 Part B (Final Quest) source-of-truth package.

const day4 = {
  id: 'day-4',
  studentId: 'anita',
  weekId: 'week-10',
  dayId: 'day-4',
  status: 'active',
  title: 'Огонёк карты и плана: маршрут, время и цель / Light of Map and Plan: Route, Time and Goal',
  shortTitle: 'Карта и план / Map and Plan',
  theme: 'Анита повторяет карты, координаты, маршруты, время, цели и маленькие шаги. / Anita reviews maps, coordinates, routes, time, goals and small steps.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'quest', 'map', 'time', 'goal', 'spelling', 'creative', 'speech'],
  questMode: true,
  questLight: 'map-plan',
  questMeta: { lightId: 'map-plan-light', lightNameRu: 'Огонёк карты и плана', lightNameEn: 'Light of Map and Plan', questNode: 4, passportStamp: 'карта-план' },
  nimnyIntro:
    'Нимни открывает четвёртый огонёк. Он светит над картой финального пути. Чтобы пройти дальше, Анита вспоминает компас, координаты, маршрут, время и цель. Это не экзамен — это квестовый шаг к финальным воротам. / Nimny opens the fourth light. It shines over the final route map. To move forward, Anita reviews compass, coordinates, route, time and goal. This is not an exam — it is one quest step toward the final gate.',
  goals: [
    'Повторить карту, координаты и маршрут. / Review map, coordinates and route.',
    'Посчитать шаги, время и план. / Count steps, time and plan.',
    'Вспомнить цель и маленькие шаги. / Review goal and small steps.',
    'Сделать печать огонька карты и плана. / Make the Map and Plan light stamp.',
    'Объяснить родителю, как карта и план помогают действовать. / Explain how map and plan help us act.'
  ],
  vocabulary: [
    { term: 'карта / map', definition: 'рисунок места или пути. / a drawing of a place or path.' },
    { term: 'компас / compass', definition: 'помогает понять стороны света. / helps to know directions.' },
    { term: 'координата / coordinate', definition: 'точка на сетке, например C4. / a point on a grid, e.g. C4.' },
    { term: 'маршрут / route', definition: 'путь от старта к финишу. / a path from start to finish.' },
    { term: 'время / time', definition: 'когда и сколько длится действие. / when and how long something lasts.' },
    { term: 'план / plan', definition: 'шаги к цели. / steps to a goal.' },
    { term: 'цель / goal', definition: 'то, к чему мы идём. / what we are heading toward.' },
    { term: 'шаг / step', definition: 'маленькое действие. / a small action.' },
    { term: 'огонёк / light', definition: 'знак знания в финальном квесте. / a sign of knowledge in the final quest.' },
    { term: 'вывод / conclusion', definition: 'что я поняла. / what I understood.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова огонька карты / Map Light Words',
      prompt: 'Прочитай по-русски:\n\nкарта\nкомпас\nкоордината\nмаршрут\nвремя\nплан\nцель\nшаг\nогонёк\nвывод',
      ruPrimaryText: 'Прочитай 10 русских слов огонька карты.',
      enHelpText: 'Read the Russian quest words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай по-русски:\n\nКарта помогает найти путь.\nКоордината показывает точное место.\nПлан помогает идти к цели маленькими шагами.\nВремя помогает понять, сколько длится дело.',
      ruPrimaryText: 'Прочитай 4 фразы про карту, план и время.',
      enHelpText: 'A map helps find a path. A coordinate shows an exact place. A plan helps move toward a goal by small steps. Time helps know how long something takes.',
      answer: 'Attempted Russian reading.' },
    { id: 'quest-map-route', type: 'text', title: 'Задание 3 — Маршрут по карте / Route on the Map',
      prompt: 'Прочитай карту Нимни:\n\n     A   B   C   D   E\n5   .   .   H   .   F\n4   .   T   .   .   .\n3   S   .   .   B   .\n2   .   .   W   .   .\n1   .   .   .   .   .\n\nLegend:\nS = старт\nF = финиш\nH = место помощи\nT = дерево\nW = вода\nB = мост\n. = пустая клетка\n\nОтветь:\n1. Где старт S?\n2. Где финиш F?\n3. Где место помощи H?\n4. Где мост B?',
      ruPrimaryText: 'Найди 4 координаты на карте Нимни.',
      enHelpText: 'Find 4 coordinates on the Nimny quest map.',
      answer: '1) A3. 2) E5. 3) C5. 4) D3.' },
    { id: 'math-route-steps', type: 'text', title: 'Задание 4 — Считаем маршрут / Count the Route',
      prompt: 'Нимни идёт от старта A3 к месту помощи C5, а потом к финишу E5.\n\nПуть:\nA3 → B3 → C3 → C4 → C5 → D5 → E5\n\nОтветь:\n1. Сколько всего переходов от клетки к клетке?\n2. Сколько переходов до места помощи C5?\n3. Сколько переходов от C5 до финиша E5?\n4. Если каждый переход стоит 2 нима энергии в учебной игре, сколько энергии нужно на весь путь?',
      ruPrimaryText: 'Реши 4 задачи о маршруте по карте.',
      enHelpText: 'Solve 4 route-counting tasks.',
      answer: '1) 6 переходов. 2) 4 перехода. 3) 2 перехода. 4) 6 × 2 = 12 нимов энергии.' },
    { id: 'math-time-plan', type: 'text', title: 'Задание 5 — Время плана / Time Plan',
      prompt: 'У Аниты есть план финального пути:\n\n1. Прочитать карту — 10 минут.\n2. Провести маршрут — 15 минут.\n3. Сделать печать огонька — 12 минут.\n4. Объяснить родителю — 8 минут.\n\nОтветь:\n1. Сколько минут займут первые два шага?\n2. Сколько минут займёт весь план?\n3. Если у Аниты есть 60 минут, сколько минут останется?\n4. Если она делает 3 таких коротких проекта по 15 минут, сколько минут всего?',
      ruPrimaryText: 'Реши 4 задачи о времени плана.',
      enHelpText: 'Solve 4 time-plan tasks.',
      answer: '1) 10 + 15 = 25 минут. 2) 10 + 15 + 12 + 8 = 45 минут. 3) 60 − 45 = 15 минут. 4) 3 × 15 = 45 минут.' },
    { id: 'goal-step-sort', type: 'classify', title: 'Задание 6 — Цель или шаг? / Goal or Step?',
      prompt: 'Разложи карточки.\n\nКатегории:\nЦель\nШаг к цели\nЛишнее или отвлекает\n\nКарточки:\n1. Сделать карту финального пути.\n2. Нарисовать старт.\n3. Нарисовать финиш.\n4. Посчитать переходы.\n5. Объяснить родителю.\n6. Листать ролики вместо проекта.\n7. Проверить, что на карте нет реального адреса.\n8. Сделать огонёк карты и плана.\n9. Попросить родителя помочь, если трудно.\n10. Добавить настоящий домашний адрес на карту.\n11. Прочитать координаты.\n12. Убрать личные данные из проекта.',
      ruPrimaryText: 'Разложи 12 карточек: цель / шаг к цели / лишнее.',
      enHelpText: 'Sort 12 cards: goal / step / distraction.',
      categories: [
        { id: 'goal', label: 'Цель / Goal' },
        { id: 'step', label: 'Шаг к цели / Step toward goal' },
        { id: 'distraction', label: 'Лишнее или отвлекает / Distraction' }
      ],
      items: [
        { id: 'g1', label: '1. Сделать карту финального пути.', category: 'goal' },
        { id: 'g2', label: '2. Нарисовать старт.', category: 'step' },
        { id: 'g3', label: '3. Нарисовать финиш.', category: 'step' },
        { id: 'g4', label: '4. Посчитать переходы.', category: 'step' },
        { id: 'g5', label: '5. Объяснить родителю.', category: 'step' },
        { id: 'g6', label: '6. Листать ролики вместо проекта.', category: 'distraction' },
        { id: 'g7', label: '7. Проверить, что на карте нет реального адреса.', category: 'step' },
        { id: 'g8', label: '8. Сделать огонёк карты и плана.', category: 'goal' },
        { id: 'g9', label: '9. Попросить родителя помочь, если трудно.', category: 'step' },
        { id: 'g10', label: '10. Добавить настоящий домашний адрес на карту.', category: 'distraction' },
        { id: 'g11', label: '11. Прочитать координаты.', category: 'step' },
        { id: 'g12', label: '12. Убрать личные данные из проекта.', category: 'step' }
      ],
      answer: 'Цель: 1, 8. Шаг к цели: 2, 3, 4, 5, 7, 9, 11, 12. Лишнее или отвлекает: 6, 10.' },
    { id: 'spelling-map-plan', type: 'text', title: 'Задание 7 — Правописание / Spelling',
      prompt: 'Напиши:\n\nкарта\nплан\nцель\nвремя\nшаг\n\nВставь буквы:\n\nк_рта\nпл_н\nц_ль\nвр_мя\nш_г',
      ruPrimaryText: 'Напиши 5 слов и вставь пропущенные буквы.',
      enHelpText: 'Write 5 words and fill in the missing letters.',
      answer: 'карта, план, цель, время, шаг.' },
    { id: 'creative-map-light-stamp', type: 'text', title: 'Задание 8 — Печать огонька карты / Map Light Stamp',
      prompt: 'Нарисуй печать огонька карты и плана.\n\nВ печати должны быть:\n1. маленькая карта;\n2. стрелка маршрута;\n3. один огонёк;\n4. слово «План».\n\nНапиши:\nКарта помогает мне идти к цели.',
      ruPrimaryText: 'Нарисуй печать огонька карты и плана с 4 элементами и фразой.',
      enHelpText: 'Draw the Map and Plan light stamp with 4 elements and the sentence.',
      answer: 'Open-ended. Accept if the stamp includes map, route arrow, light and the sentence attempt.' },
    { id: 'speech-map-plan', type: 'text', title: 'Задание 9 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\n\nКарта помогает найти путь.\nПлан помогает идти к цели.\nВремя помогает закончить дело.\nЯ могу идти маленькими шагами.',
      ruPrimaryText: 'Скажи родителю минимум 3 фразы про карту и план.',
      enHelpText: 'Tell parent at least 3 phrases about map and plan.',
      answer: 'Accept if Anita says most phrases in Russian with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова огонька карты.',
    '2. Прочитай 4 фразы.',
    '3. Перепиши мини-карту A–E / 1–5.',
    '4. Найди S, F, H и B.',
    '5. Посчитай маршрут и время.',
    '6. Разложи карточки «цель / шаг / отвлекает» устно.',
    '7. Нарисуй печать огонька карты.',
    '8. Объясни родителю 4 фразы.'
  ],
  printWorksheet: {
    title: 'Огонёк карты и плана: маршрут, время и цель / Light of Map and Plan',
    subtitle: 'Неделя 10 · День 4 / Week 10 · Day 4 · Quest Passport',
    pages: [
      { title: 'Огонёк карты и плана / Map and Plan Light',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Нимни открывает четвёртый огонёк. Сегодня ты вспоминаешь карту, координаты, маршрут, время и план.' },
          { type: 'text', text: 'Задание 1 — Слова огонька карты. Прочитай и обведи:' },
          { type: 'list', items: [
            'карта / map',
            'компас / compass',
            'координата / coordinate',
            'маршрут / route',
            'время / time',
            'план / plan',
            'цель / goal',
            'шаг / step',
            'огонёк / light',
            'вывод / conclusion'
          ] },
          { type: 'text', text: 'Задание 2 — Маленькое чтение. Поставь галочку:' },
          { type: 'list', items: [
            '□ Карта помогает найти путь.',
            '□ Координата показывает точное место.',
            '□ План помогает идти к цели маленькими шагами.',
            '□ Время помогает понять, сколько длится дело.'
          ] }
        ] },
      { title: 'Карта и время / Map and Time',
        blocks: [
          { type: 'text', text: 'Задание 3 — Маршрут по карте.' },
          { type: 'list', items: [
            '     A   B   C   D   E',
            '5   .   .   H   .   F',
            '4   .   T   .   .   .',
            '3   S   .   .   B   .',
            '2   .   .   W   .   .',
            '1   .   .   .   .   .'
          ] },
          { type: 'text', text: 'Legend: S = старт, F = финиш, H = место помощи, T = дерево, W = вода, B = мост, . = пустая клетка.' },
          { type: 'list', items: [
            '1. Старт S: ______',
            '2. Финиш F: ______',
            '3. Место помощи H: ______',
            '4. Мост B: ______'
          ] },
          { type: 'text', text: 'Задание 4 — Считаем маршрут. Путь: A3 → B3 → C3 → C4 → C5 → D5 → E5.' },
          { type: 'list', items: [
            '1. Всего переходов: ______',
            '2. До места помощи C5: ______',
            '3. От C5 до финиша E5: ______',
            '4. Энергия: ______ × 2 = ______ нимов энергии (6 × 2 = 12)'
          ] },
          { type: 'text', text: 'Задание 5 — Время плана. Прочитать карту 10, маршрут 15, печать 12, объяснить 8.' },
          { type: 'list', items: [
            '1. Первые два шага: 10 + 15 = ______',
            '2. Весь план: 10 + 15 + 12 + 8 = ______ (45)',
            '3. Если есть 60 минут, останется: ______',
            '4. 3 проекта по 15 минут: 3 × 15 = ______ (45)'
          ] }
        ] },
      { title: 'Печать огонька / Light Stamp',
        blocks: [
          { type: 'text', text: 'Задание 6 — Цель или шаг? Напиши Ц = цель, Ш = шаг, Л = лишнее.' },
          { type: 'list', items: [
            '1. Сделать карту финального пути. ____',
            '2. Нарисовать старт. ____',
            '3. Нарисовать финиш. ____',
            '4. Посчитать переходы. ____',
            '5. Объяснить родителю. ____',
            '6. Листать ролики вместо проекта. ____',
            '7. Проверить, что на карте нет реального адреса. ____',
            '8. Сделать огонёк карты и плана. ____',
            '9. Попросить родителя помочь, если трудно. ____',
            '10. Добавить настоящий домашний адрес на карту. ____',
            '11. Прочитать координаты. ____',
            '12. Убрать личные данные из проекта. ____'
          ] },
          { type: 'text', text: 'Задание 7 — Правописание. Напиши и вставь буквы:' },
          { type: 'list', items: [
            'карта   план   цель   время   шаг',
            'к_рта   пл_н   ц_ль   вр_мя   ш_г'
          ] },
          { type: 'text', text: 'Задание 8 — Печать огонька карты. Нарисуй печать. В ней должны быть:' },
          { type: 'list', items: [
            '□ маленькая карта',
            '□ стрелка маршрута',
            '□ один огонёк',
            '□ слово «План»'
          ] },
          { type: 'text', text: 'Фраза: Карта помогает мне идти к цели. ______________________________' },
          { type: 'text', text: 'Задание 9 — Объясни родителю. Поставь галочку:' },
          { type: 'list', items: [
            '□ Карта помогает найти путь.',
            '□ План помогает идти к цели.',
            '□ Время помогает закончить дело.',
            '□ Я могу идти маленькими шагами.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала 4 фразы  □ Нашла координаты  □ Посчитала маршрут и время  □ Сделала печать огонька  □ Объяснила родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита повторяет карты, координаты, маршрут, время и план как часть финального квеста.',
    mathGoal: 'Координаты, маршрут по клеткам, умножение 6 × 2, сложение времени, вычитание из 60, умножение 3 × 15.',
    russianGoal: 'Прочитать слова карта, компас, координата, маршрут, время, план, цель, шаг, огонёк, вывод.',
    readingWritingGoal: 'Прочитать 4 фразы, написать 5 слов, сделать печать огонька и фразу.',
    practicalGoal: 'Связать карту, план и время: путь легче пройти, если есть маршрут и маленькие шаги.',
    parentTheoryCard: {
      title: 'Как объяснить карту и план в финальном квесте',
      purpose: 'Помочь родителю связать географию, время и самостоятельность в одном простом смысле.',
      keyMessage: 'Карта показывает путь, план показывает шаги, время помогает довести дело до конца.',
      parentScript: [
        '«Карта помогает понять, куда идти.»',
        '«План помогает не бросить дело.»',
        '«Время помогает увидеть, сколько займёт путь.»',
        '«Большая цель становится легче, если идти маленькими шагами.»'
      ],
      practiceSteps: [
        'Посмотрите мини-карту.',
        'Найдите старт, помощь и финиш.',
        'Посчитайте переходы.',
        'Посчитайте время плана.',
        'Попросите Аниту объяснить, зачем нужен план.'
      ],
      doNotSay: [
        'Не превращать квест в экзамен.',
        'Не требовать идеального маршрута.',
        'Не обсуждать реальные домашние маршруты онлайн.'
      ],
      paperOnlyNotes: [
        'Можно делать карту в тетради.',
        'Все маршруты вымышленные.',
        'Реальные семейные маршруты обсуждаются только устно с родителем.'
      ]
    },
    whatThisLessonTeaches: 'Анита повторяет, что путь, время и цель можно соединить в понятный план.',
    keyMessage: 'Я могу идти к цели маленькими шагами.',
    howToExplain: 'Скажите: «Если у тебя есть карта, ты видишь путь. Если есть план, ты знаешь шаги. Если считаешь время, ты понимаешь, как закончить.»',
    exampleDialogue:
      'Parent: Где старт?\nChild: A3.\nParent: Где финиш?\nChild: E5.\nParent: Что помогает пройти путь?\nChild: Карта и план.',
    readingSupport: 'Слова «координата», «маршрут», «огонёк» читать по частям.',
    russianSpeechGoal: 'Анита говорит: «Карта помогает найти путь. План помогает идти к цели.»',
    mathAnswerKey:
      'quest-map-route: 1) A3. 2) E5. 3) C5. 4) D3.\nmath-route-steps: 1) 6. 2) 4. 3) 2. 4) 12.\nmath-time-plan: 1) 25. 2) 45. 3) 15. 4) 45.\ngoal-step-sort: Цель: 1, 8. Шаг к цели: 2, 3, 4, 5, 7, 9, 11, 12. Лишнее или отвлекает: 6, 10.',
    spellingAnswerKey: 'карта\nплан\nцель\nвремя\nшаг',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения.' },
      { taskId: 'quest-map-route', answer: 'A3; E5; C5; D3.' },
      { taskId: 'math-route-steps', answer: '6; 4; 2; 12.' },
      { taskId: 'math-time-plan', answer: '25; 45; 15; 45.' },
      { taskId: 'goal-step-sort', answer: 'цель 1,8; шаг 2,3,4,5,7,9,11,12; лишнее 6,10.' },
      { taskId: 'spelling-map-plan', answer: 'карта, план, цель, время, шаг.' },
      { taskId: 'creative-map-light-stamp', answer: 'печать с картой, стрелкой, огоньком и словом «План».' },
      { taskId: 'speech-map-plan', answer: 'Объяснение родителю.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита нашла координаты.',
      'Анита посчитала маршрут.',
      'Анита посчитала время.',
      'Анита сделала печать огонька.',
      'Анита объяснила родителю.'
    ],
    spellingCheck: 'Проверить карта, план, цель, время, шаг.',
    readingCheck: 'Главное — попытка русского чтения.',
    practicalCheck: 'Анита понимает связь: карта → путь, план → шаги, время → завершение.',
    drawingCriteria: 'Печать содержит карту, стрелку, огонёк и слово «План».',
    commonMistakes: [
      '«План нужен только взрослым.» Правильно: «План помогает ребёнку тоже.»',
      '«Карта — просто рисунок.» Правильно: «Карта помогает найти путь.»',
      '«Цель надо сделать сразу.» Правильно: «К цели идут маленькими шагами.»'
    ],
    discussionPrompts: [
      'Чем карта помогает?',
      'Чем план помогает?',
      'Почему время полезно считать?',
      'Какой маленький шаг можно сделать первым?'
    ],
    ifEasy: 'Пусть Анита придумает второй маршрут к финишу и сравнит шаги.',
    ifDifficult: 'Оставить только карту и 3 точки: старт, помощь, финиш.',
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за точный маршрут или аккуратную печать.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не использовать реальные адреса, школу или маршрут домой.',
    safetyNotes: 'Все карты вымышленные. Реальные маршруты не вводятся онлайн.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'precise-route', label: 'Бонус за точный маршрут', amount: 1 },
      { id: 'neat-map-stamp', label: 'Бонус за аккуратную печать огонька карты', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'quest-map-route', 'math-route-steps', 'math-time-plan', 'goal-step-sort', 'spelling-map-plan', 'creative-map-light-stamp', 'speech-map-plan'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-10-day-5'
};

export default day4;
